import { GranthikaError } from '@/help'
import iso_fetch from 'isomorphic-fetch'

export class ServerResponse { 
  ok: boolean = true
  error?: string
  errorType?: string 
}

export async function get<ResponseType extends ServerResponse>
        (path : string, authorization : string) : Promise<ServerResponse> {
  let response = await iso_fetch("/console/rest" + path, {
    headers: {
      'Accept': 'application/json',
      'Authorization' : authorization
    },
  })
  if (!response.ok) {
    console.error('While posting on ' + path, 'response is', response, (await response.text()))
    throw new GranthikaError({ok:false, error: response.statusText, errorType: GranthikaError.FAILED_REQUEST})
  }
  let asJson = await response.json()
  if (!asJson.ok) {
    console.error('While getting on ' + path, 'response is', response)
    throw new GranthikaError(asJson)
  }
  else
    return asJson
}

export async function post<ResponseType extends ServerResponse>
        (path : string, payload : object, authorization : string): Promise<ResponseType> {
  try {
    let response = await iso_fetch("/console/rest" + path, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization' : authorization
      },
      method: 'POST',
      body: JSON.stringify(payload)
    })
    if (!response.ok) {
      console.error('While posting on ' + path, payload, 'response is', response, (await response.text()))
      throw new GranthikaError({ok:false, error: response.statusText, errorType: GranthikaError.FAILED_REQUEST})
    }
    let asJson: { ok: boolean, error: string, errorType? : string } = await response.json()
    //console.log('response ', asJson)
    if (!asJson.ok) {
      console.error('While posting on ' + path, payload, 'response is', response)
      throw new GranthikaError(asJson)
    }
    else
      return asJson as ResponseType
  }
  catch (err) {
    // console.error('While posting to ' + path, payload, err)
    throw err
  }
}